<template>
  <div class="jump-setup">
    <div class="jump-setup-item">
      <!-- <a-checkbox v-model:checked="params.isCopy"> 跳过已复制的商品</a-checkbox>
      &nbsp;&nbsp; -->
      <a-checkbox v-model:checked="params.skip_has_brand"> 跳过有品牌的商品</a-checkbox>
    </div>
    <div class="jump-setup-item">
      跳过库存小于
      <a-input-number placeholder="请输入数字" style="width: 110px" v-model:value="params.skip_stock_low" />
      的商品
    </div>
    <div class="jump-setup-item">
      跳过来源价小于
      <a-input-number placeholder="请输入数字" style="width: 110px" v-model:value="params.skip_price_less" />
      元的商品
      &nbsp;&nbsp;
      跳过来源价大于
      <a-input-number placeholder="请输入数字" style="width: 110px" v-model:value="params.skip_price_more" />
      元的商品
    </div>
    <div class="jump-setup-item flex">
      <div class="flex">
          跳过标题中包含&nbsp;
          <a-textarea
            v-model:value="params.skip_title_has_keywords"
            style="width: 420px"
            placeholder="若有多个关键词, 请用逗号隔开"
            :auto-size="{ minRows: 1, maxRows: 5 }"
          />
          &nbsp;的商品
      </div>
    </div>
    <div class="jump-setup-item flex">
      <div class="flex">
          跳过SKU中包含&nbsp;
          <a-textarea
            v-model:value="params.skip_sku_has_keywords"
            style="width: 420px"
            placeholder="若有多个关键词, 请用逗号隔开"
            :auto-size="{ minRows: 1, maxRows: 5 }"
          />
          &nbsp;的商品
      </div>
    </div>
    <div class="jump-setup-item flex">
      <div class="flex">
          跳过品牌中包含&nbsp;
          <a-textarea
            v-model:value="params.skip_brand_has_keywords"
            style="width: 420px"
            placeholder="若有多个关键词, 请用逗号隔开"
            :auto-size="{ minRows: 1, maxRows: 5 }"
          />
          &nbsp;的商品
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      params: {
        skipHasBrand: false,
        skipStockLow: null,
        skipPriceLess: null,
        skipPriceMore: null,
        skipTitleHasKeywords: null,
        skipSkuHasKeywords: null,
        skipBrandHasKeywords: null
      }
    }
  },
  methods: {
    setParams(obj) {
      this.params = {
        skipHasBrand: obj.skipHasBrand || false,
        skipStockLow: obj.skipStockLow || null,
        skipPriceLess: obj.skipPriceLess || null,
        skipPriceMore: obj.skipPriceMore || null,
        skipTitleHasKeywords: obj.skipTitleHasKeywords,
        skipSkuHasKeywords: obj.skipSkuHasKeywords,
        skipBrandHasKeywords: obj.skipBrandHasKeywords
      }
    },
    getParams() {
      const params = this.params
      params.skipTitleHasKeywords = params.skipTitleHasKeywords?.replaceAll('，', ',')
      params.skipSkuHasKeywords = params.skipSkuHasKeywords?.replaceAll('，', ',')
      params.skipBrandHasKeywords = params.skipBrandHasKeywords?.replaceAll('，', ',')
      return params
    }
  }
}
</script>
<style scoped lang='less'>
  @import './index';
</style>